import React, { useEffect, useMemo, useState } from 'react';
import { createUser, getUserRoles, setErrors } from '../../../store/users/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { fetchMicrosoftUsers } from '../../../store/auth/actions';
import FormFieldInput from './FormFieldInput';

const AddUser = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, roles, errors } = useSelector((state) => state.Users);
    const { microsoftUsers } = useSelector((state) => state.Auth);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        // password: '',
        azure_account: true,
        sendUserNotification: false,
        role: '',
    });

    const emailOptions = useMemo(() => {
        if (!Array.isArray(microsoftUsers)) return [];

        return microsoftUsers
            .map(user => user.mail)
            .filter(email => typeof email === "string" && email.trim() !== "");
    }, [microsoftUsers]);

    const rolesList = useMemo(() => roles.map(({ _id, title }) => {
        return { value: _id, label: title }
    }), [roles]);

    useEffect(() => {
        setFormData({
            name: '',
            email: '',
            // password: '',
            azure_account: true,
            sendUserNotification: false,
            role: '',
        });
    }, []);

    useEffect(() => {
        setFormData({
            name: '',
            email: '',
            // password: '',
            azure_account: true,
            sendUserNotification: false,
            role: '',
        });
        dispatch(getUserRoles());
        dispatch(fetchMicrosoftUsers());
        // dispatch(setErrors({ name: '', email: '', password: '', role: '' }));
        dispatch(setErrors({ name: '', email: '', role: '' }));
    }, [navigate, dispatch]);

    const handleInputChange = (key, value) => {
        // if (key === 'azure_account') {
        //     value = Boolean(value);
        //     dispatch(setErrors({ ...errors, password: '' }));
        //     setFormData(prev => ({
        //         ...prev,
        //         azure_account: value
        //     }));
        // } else {
            setFormData(prev => ({ ...prev, [key]: value }));
        // }

        const errorMsg = getFieldError(key, value);
        if (errorMsg) {
            dispatch(setErrors({ ...errors, [key]: errorMsg }));
        } else {
            dispatch(setErrors({ ...errors, [key]: '' }));
        }
    };

    const getFieldError = (fieldName, value) => {
        switch (fieldName) {
            case 'name':
                return /^.{2,}$/.test(value) ? '' : 'Name must be at least 2 characters.';
            case 'email':
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Please enter a valid email.';
            // case 'password':
            //     if (formData.azure_account) return '';
            //     if (!value || value.length < 8) return 'Password must be at least 8 characters.';
            //     if (!/[a-zA-Z]/.test(value)) return 'Password must include at least one letter.';
            //     if (!/\d/.test(value)) return 'Password must include at least one number.';
            //     if (!/[!@#$%^&*()?_+]/.test(value)) return 'Password must include at least one special character (!@#$%^&*()?_+).';
            //     return '';
            case 'role':
                return value ? '' : 'Please select a role.';
            default:
                return '';
        }
    };

    const saveUser = async (event) => {
        event.preventDefault();
        const newErrs = {};
        Object.keys(formData).forEach(key => {
            // if ((key === 'password' && formData.azure_account) || key === 'sendUserNotification' || key === 'azure_account') {
            //     return;
            // }
            if (key === 'sendUserNotification' || key === 'azure_account') {
                return;
            }
            const error = getFieldError(key, formData[key]);
            if (error) {
                newErrs[key] = error;
            }
        });
        dispatch(setErrors(newErrs));
        if (Object.keys(newErrs).length === 0) {
            const dataToSubmit = { ...formData };
            // if (formData.azure_account) {
            //     delete dataToSubmit.password;
            // }
            delete dataToSubmit.sendUserNotification;
            dispatch(createUser({ formData: dataToSubmit, navigate }));
        }
    };

    return (
        <>
            {/* <ModuleHeader className="text-2xl font-bold text-primary" title="Add New User" /> */}
            {/* <p className="text-gray-600 text-sm mb-4">Create a brand new user and add them to this site.</p> */}
            <Card className="w-full mb-4">
                <CardHeader>Add New User</CardHeader>
                <CardContent className="p-6">
                    <form>
                        <div className="flex flex-col gap-6 w-full px-2 sm:px-4">
                            <FormFieldInput
                                field="name"
                                fieldType="text"
                                value={formData.name}
                                handleInputChange={handleInputChange}
                                required={true}
                                error={errors?.name || ""}
                            />

                            {/* <FormFieldInput
                                field="azure_account"
                                fieldType="checkbox"
                                label="SSO Account"
                                value={formData?.azure_account || false}
                                handleInputChange={handleInputChange}
                                required={true}
                                checkboxLabel="Is this an SSO Account?"
                            /> */}

                            <FormFieldInput
                                field="email"
                                fieldType="email"
                                value={formData?.email || ""}
                                options={emailOptions}
                                isLoading={loading}
                                handleInputChange={handleInputChange}
                                required={true}
                                error={errors?.email || ""}
                            />

                            {/* <FormFieldInput
                                field="password"
                                fieldType="password"
                                value={formData?.password || ""}
                                handleInputChange={handleInputChange}
                                required={!formData.azure_account ? true : false}
                                error={errors?.password || ""}
                                className={!formData.azure_account ? "block" : "hidden"}
                            /> */}

                            <FormFieldInput
                                field="role"
                                fieldType="select"
                                label="Role"
                                options={rolesList}
                                value={formData?.role || ""}
                                handleInputChange={handleInputChange}
                                required={true}
                                error={errors?.role || ""}
                            />
                        </div>
                    </form>

                    <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4">
                        <Button variant="outline" className="w-full sm:w-auto" onClick={() => navigate("/users")}>Back</Button>
                        <Button className="w-full sm:w-auto" onClick={saveUser}>Add New User</Button>
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

export default AddUser;
